'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--YoukoWithCircle';

var EntypoYoukoWithCircle = function EntypoYoukoWithCircle(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,0.3999634c-5.3019409,0-9.5999756,4.2980957-9.5999756,9.6000366S4.6980591,19.5999756,10,19.5999756S19.5999756,15.3019409,19.5999756,10S15.3019409,0.3999634,10,0.3999634z M9.5961046,9.479475c-0.5966415,1.3512201-1.0866251,2.4801579-1.6634593,3.7867804c-0.2821755,0.6385441-0.5021729,1.344305-1.0208726,1.6835604c-2.1434216,0.1347885-0.543664-2.2535963-0.2269125-3.0987167c-0.4872293-0.9295101-1.125421-2.0113297-1.7012587-3.0218296C4.7212338,8.3683529,4.0666919,7.4897113,4.719007,6.9928126c0.2411532-0.1834874,0.7764959-0.1888204,1.0207553,0c0.7572155,0.5862107,1.186017,2.1857924,1.8147149,2.9074359c0.2324214-0.3994417,0.4419875-0.947794,0.6805034-1.4920444c0.2165985-0.4946723,0.3959255-1.1898851,0.71842-1.4153914c0.4933243-0.3445883,1.2599745-0.0451832,1.3610067,0.4589825C10.4414597,8.08776,9.8440561,8.9177608,9.5961046,9.479475z M14.5863667,12.7689466c-0.3965702-0.0859127-0.7570982-0.6471586-1.1338606-0.9947357c-0.3925257-0.3611727-0.8263083-0.6891766-1.1343288-0.9941492c-0.2100935-0.3200331-0.1513729,0.2170677-0.1513729,0.5354013v0.9183168c-0.0408459,0.3280029-0.2179461,0.518816-0.5291891,0.5735521h-0.4537668c-0.3274174-0.0385609-0.4635534-0.2705135-0.5291891-0.5735521V7.9876065c0.005743-0.811482,1.5066366-0.811482,1.512145,0V9.479475c0.2422085-0.1249428,0.3878384-0.3469324,0.5672817-0.5358696c0.1543036-0.1242399,0.2930765-0.2644196,0.4156752-0.4208317c0.2552176-0.2263269,0.49473-0.4684181,0.7184191-0.7266245c0.2984676-0.626061,1.4621572-0.5832219,1.5500622,0.1914573c0.121954,1.0725608-1.322094,1.4504943-1.5877438,2.0655971c0.3942251,0.5366898,1.3082638,0.9243517,1.6256018,1.5301943C15.7566776,12.1564817,15.3984346,12.9451675,14.5863667,12.7689466z' })
    );
};

exports.default = EntypoYoukoWithCircle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/YoukoWithCircle.js
// module id = ./node_modules/react-entypo/lib/entypo/YoukoWithCircle.js
// module chunks = 2